import {IMgmCard} from "apps/BWW_PLAY_HUB/modules/reducers/mgmCards";
import {createAction} from "redux-act";

export const fetchMgmCardsJSON = createAction();
export const fetchMgmCardsJSONSuccess = createAction<IMgmCard[]>();
export const fetchMgmCardsJSONFailed = createAction();
